// ArticleCardList.jsx
import React, { useState } from "react";
import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ArticleCardList({ articles = [] }) {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [hoverTimelineId, setHoverTimelineId] = useState(null);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)", // luôn 3 cột
        gap: 3,
      }}
    >
      {articles.map((article) => (
        <Card
          key={article.id}
          onClick={() => navigate(`/articles/${article.id}`)}
          sx={{
            width: '312px',
            borderTop: "3px solid red",
            boxShadow: "none",
            borderRadius: 0,
            position: "relative",
            cursor: "pointer",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
            "&:hover": {
              transform: "scale(1.02)",
              boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
            },
          }}
        >
          <CardMedia
            component="img"
            image={
              article.thumbnail
                ? `${BASE_URL}${article.thumbnail}`
                : "https://via.placeholder.com/312x312.png?text=No+Image"
            }
            alt={article.title}
            sx={{ width: "100%", height: 312, objectFit: "cover" }}
          />

          <Box
            sx={{
              position: "absolute",
              top: 312,
              left: 0,
              width: "4px",
              height: "calc(100% - 312px - 16px)",
              backgroundColor: "red",
            }}
          />

          <CardContent sx={{ flexGrow: 1, p: 1.5 }}>
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              sx={{ mb: 2, fontSize: 18 }}
            >
              {article.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "#444", mb: 2 }}>
              {article.description?.substring(0, 100)}...
            </Typography>
            <Typography variant="caption" sx={{ color: "gray" }}>
              {new Date(article.created_at).toLocaleDateString("vi-VN")}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
